import { FC } from 'react'

/**
 *
 */
const SectionTitle: FC = ({ children }) => <h2 className="text-xl font-bold">{children}</h2>

export default SectionTitle
